import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InsuranceCompany } from "../../../../interfaces/screens/billing";
import {
  fetchInsurers,
  addInsurer,
  updateInsurer,
  deleteInsurer,
} from "./actions";

interface InsurersState {
  data: InsuranceCompany[];
  loading: boolean;
  error: string | null;
}

const initialState: InsurersState = {
  data: [],
  loading: false,
  error: null,
};

const insurersSlice = createSlice({
  name: "insurers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInsurers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchInsurers.fulfilled,
        (state, action: PayloadAction<InsuranceCompany[]>) => {
          state.loading = false;
          state.data = action.payload;
        },
      )
      .addCase(fetchInsurers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch insurers";
      })
      .addCase(
        addInsurer.fulfilled,
        (state, action: PayloadAction<InsuranceCompany>) => {
          state.data.push(action.payload);
        },
      )
      .addCase(
        updateInsurer.fulfilled,
        (state, action: PayloadAction<InsuranceCompany>) => {
          const index = state.data.findIndex((i) => i.id === action.payload.id);
          if (index !== -1) {
            state.data[index] = action.payload;
          }
        },
      )
      .addCase(
        deleteInsurer.fulfilled,
        (state, action: PayloadAction<string>) => {
          state.data = state.data.filter((i) => i.id !== action.payload);
        },
      );
  },
});

export default insurersSlice.reducer;
